module.exports = __webpack_public_path__ + "img/54.b1a7478c.jpg";